import React from "react"
import Slider from "react-slick"

const HotelCarousel = ({blok}) => {  
  // console.log(blok)
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
  }

  return (
    <Slider {...settings} >{blok?.map((img,index) => 
      <div className="relative" key={index}>
        <img className="w-full h-[250px] object-cover" loading="lazy" src={`${img?.filename}/m/0x500`} alt={img.alt} key={index} />
        {img?.copyright && (
          <span className="absolute bottom-0 text-xs text-white p-1 bg-black bg-opacity-15">
            &copy; {img?.copyright}
          </span>
        )}
      </div>
    )}</Slider>
  )
}
  
export default HotelCarousel
